import {
  SexFilter,
  StagesFilter,
  UsersTasksPlanned,
} from "@/app/leads/leads.api";

export interface CatchmentRequest {
  branch_filter: null;
  company_filter: null;
  sex_filter: SexFilter;
  stages_filter: StagesFilter;
  campaign_filter: 2;
  is_in_campaign_filter: boolean;
  users_tasks_planned: UsersTasksPlanned;
  max_lead: 10;
  search: string;
  catchment_page: string;
  isCreateModalOpen: boolean;
}

export interface PageState {
  formValues: CatchmentRequest;
  selectedBranch: any | null;
  selectedCompany: any | null;
  openUserModal: boolean;
  selectPersonRegister: any;
  isCreateModalOpen: boolean;
  isDrawerOpen: boolean;
  isKpisOpen: boolean;
}

export type PageAction =
  | { type: "SET_FORM_VALUES"; values: Partial<CatchmentRequest> }
  | { type: "SET_SELECTED_BRANCH"; branch: any }
  | { type: "SET_SELECTED_COMPANY"; company: any }
  | { type: "TOGGLE_USER_MODAL" }
  | { type: "SET_PERSON_REGISTER"; person: any }
  | { type: "CHANGE_TAB"; tabId: string }
  | { type: "SET_FILTER"; field: string; value: any }
  | { type: "TOGGLE_CREATE_MODAL" }
  | { type: "TOGGLE_DRAWER" }
  | { type: "TOGGLE_KPIS" }
  | { type: "RESET" };

export const initialState: PageState = {
  formValues: {
    branch_filter: null,
    company_filter: null,
    sex_filter: null,
    stages_filter: null,
    campaign_filter: null,
    is_in_campaign_filter: true,
    users_tasks_planned: null,
    max_lead: 10,
    search: "",
    catchment_page: "campaigns",
    isCreateModalOpen: false,
  },
  selectedBranch: null,
  selectedCompany: null,
  openUserModal: false,
  selectPersonRegister: {},
  isCreateModalOpen: false,
  isDrawerOpen: false,
  isKpisOpen: false,
};

export function pageReducer(state: PageState, action: PageAction): PageState {
  switch (action.type) {
    case "SET_FORM_VALUES":
      return {
        ...state,
        formValues: {
          ...state.formValues,
          ...action.values,
        },
      };

    case "SET_SELECTED_BRANCH":
      return {
        ...state,
        selectedBranch: action.branch,
        formValues: {
          ...state.formValues,
          branch_filter: action.branch?.id || null,
        },
      };
    case "SET_SELECTED_COMPANY":
      return {
        ...state,
        selectedCompany: action.company,
        formValues: {
          ...state.formValues,
          company_filter: action.company?.id || null,
        },
      };

    case "TOGGLE_USER_MODAL":
      return {
        ...state,
        openUserModal: !state.openUserModal,
      };

    case "SET_PERSON_REGISTER":
      return {
        ...state,
        selectPersonRegister: action.person,
      };

    case "CHANGE_TAB":
      return {
        ...state,
        formValues: {
          ...initialState.formValues,
          catchment_page: action.tabId,
          is_in_campaign_filter: action.tabId === "campaigns" ? true : false,
        },
      };

    case "SET_FILTER":
      return {
        ...state,
        formValues: {
          ...state.formValues,
          [action.field]: action.value,
        },
      };

    case "TOGGLE_CREATE_MODAL":
      return {
        ...state,
        isCreateModalOpen: !state.isCreateModalOpen,
      };

    case "TOGGLE_DRAWER":
      return {
        ...state,
        isDrawerOpen: !state.isDrawerOpen,
      };

    case "TOGGLE_KPIS":
      return {
        ...state,
        isKpisOpen: !state.isKpisOpen,
      };

    case "RESET":
      return initialState;

    default:
      return state;
  }
}
